import { Link } from "react-router-dom";
import { ArrowUpRight, Activity, BrainCircuit, Globe2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CHIPS = [
    { Icon: Activity, text: "24/7 NOC & SOC operations" },
    { Icon: BrainCircuit, text: "AI-assisted monitoring" },
    { Icon: Globe2, text: "Global infrastructure visibility" },
];

const Showcase = () => (
    <section data-testid="showcase-section" className="media-dark relative overflow-hidden t-bg">
        <img
            src="/visuals/visual-noc-soc-16x9.webp"
            alt="Varasun 24/7 network and security operations center"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/80 to-navy-950/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-transparent to-navy-950/60" />
        <div className="container-x relative z-10 flex min-h-[72vh] items-center py-16">
            <Reveal className="max-w-xl">
                <p className="eyebrow">Operations</p>
                <h2 className="mt-4 font-display text-2xl font-semibold leading-tight tracking-tight t-heading sm:text-3xl lg:text-4xl">
                    Mission control for your enterprise technology
                </h2>
                <p className="mt-5 text-base leading-relaxed t-soft md:text-lg">
                    Behind every transformation is an operations core that never sleeps — watching networks, cloud
                    estates, security events and application telemetry across every region you run in.
                </p>
                <ul className="mt-8 space-y-3">
                    {CHIPS.map(({ Icon, text }) => (
                        <li key={text} className="flex items-center gap-3 text-sm t-heading">
                            <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-electric/25 bg-electric/10 text-electric">
                                <Icon size={15} />
                            </span>
                            {text}
                        </li>
                    ))}
                </ul>
                <Link to="/contact" data-testid="showcase-cta" className="btn-primary mt-9">
                    See how we operate <ArrowUpRight size={15} />
                </Link>
            </Reveal>
        </div>
    </section>
);

export default Showcase;
